import clsx from "clsx";
import PropTypes from "prop-types";

const IconCircle = ({
  icon: Icon,
  link,
  onClick,
  disabled = false,
  className = "",
}) => {
  const handleClick = (e) => {
    if (disabled) return;
    if (onClick) onClick(e);
  };

  const content = (
    <div
      className={clsx(
        "w-8 h-8 p-2 flex items-center justify-center transition ease-in-out duration-300 icon-base z-10",
        {
          "cursor-pointer hover:drop-shadow-md hover:scale-110": !disabled,
          "opacity-40 cursor-not-allowed pointer-events-none": disabled,
        },
        className
      )}
      onClick={handleClick}
    >
      <Icon size={24} className="transition-transform duration-300 " />
    </div>
  );

  if (link) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        {content}
      </a>
    );
  }

  return content;
};

IconCircle.propTypes = {
  icon: PropTypes.elementType.isRequired,
  link: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default IconCircle;
